<v2-card
  [boxShadow]="false"
  [flatBottom]="true"
  class="modifier-card"
  [class.invalid]="!modifierGroup.isSelectionValid"
  id="{{ modifierGroup.id }}"
>
  <v2-card-header
    [opaque]="true"
    opaqueColor="primary-tint"
    [subtitle]="
      getModifierGroupSubtitle(
        modifierGroup,
        i18nStore.menuModifierBundle$ | async
      )
    "
    class="modifier-card-header"
  >
    <div title>
      <v2-body-small-text
        *ngIf="parentModifier"
        [color]="
          (itemDetailsStore.isSelectedItemDisabled$ | async)
            ? 'inactive-grey'
            : 'dark-grey'
        "
        class="owner-mod-name"
      >
        {{ parentModifier.name }} {{ 'Menu.Modifiers.Selected' | translate }}
      </v2-body-small-text>
      <v2-row title alignItems="baseline">
        <v2-body-header-2-text
          [color]="
            (itemDetailsStore.isSelectedItemDisabled$ | async)
              ? 'inactive-grey'
              : 'black'
          "
          >{{ modifierGroup.title }}</v2-body-header-2-text
        >
      </v2-row>
    </div>

    <v2-chip
      trailing
      [outline]="!showValidationState || modifierGroup.isSelectionValid"
      [color]="
        showValidationState && !modifierGroup.isSelectionValid
          ? 'alert-orange'
          : 'primary'
      "
      size="large"
      [class.faded-chip]="!!(itemDetailsStore.isSelectedItemDisabled$ | async)"
      *ngIf="
        modifierGroup.minimum > 0 && !(locationStore.isMenuReadonly$ | async)
      "
    >
      <v2-label-small-text
        [color]="
          showValidationState && !modifierGroup.isSelectionValid
            ? 'white'
            : 'primary'
        "
      >
        {{ 'Menu.Modifiers.Required' | translate | uppercase }}
      </v2-label-small-text>
    </v2-chip>
  </v2-card-header>
  <v2-row *ngIf="modifierGroup.guestInstructions" class="guest-instructions">
    <v2-body-small-text color="medium-grey">
      {{ modifierGroup.guestInstructions }}
    </v2-body-small-text>
  </v2-row>

  <ng-container
    *ngFor="
      let modifier of modifierGroup.modifiers;
      last as isLast;
      trackBy: uiService.stdEntityIdTrackByFn
    "
  >
    <v2-list-tile
      [ripple]="!modifier.disabled && (shouldShowRippleEffects$ | async)"
      class="modifier-group-option"
      (click)="selectModifier(modifierGroup, modifier)"
      *ngIf="
        !itemDetailsStore.isMultiModifierQuantitySelectionEnabled(modifierGroup)
      "
      [class.readonly]="locationStore.isMenuReadonly$ | async"
      [class.disabled]="
        modifier.disabled || (locationStore.isMenuReadonly$ | async)
      "
    >
      <v2-checkbox
        leading
        [shape]="modifierGroup.maximum === 1 ? 'circle' : 'square'"
        [checked]="modifier.isSelected"
        fillMode="solid"
        [disabled]="modifier.disabled"
        *ngIf="!(locationStore.isMenuReadonly$ | async)"
      ></v2-checkbox>

      <v2-column title>
        <v2-body-text [color]="getModifierTextColor(modifier, 'dark-grey')">
          {{ modifier.name }}
        </v2-body-text>
        <v2-body-small-text
          *ngIf="modifier.description"
          [color]="getModifierTextColor(modifier, 'medium-grey')"
          class="modifier-description"
        >
          {{ modifier.description }}
        </v2-body-small-text>
      </v2-column>

      <v2-row
        trailing
        alignItems="center"
        *ngIf="isModifierSelectable(modifier)"
      >
        <v2-chip
          [color]="modifier.isSelected ? 'primary-tint' : 'white'"
          size="small"
          *ngIf="calculateTotalPrice(modifier) as totalPrice"
          [class.no-padding]="locationStore.isMenuReadonly$ | async"
        >
          <v2-body-header-heavy-text
            [color]="getModifierTextColor(modifier, 'medium-grey')"
            class="modifier-price-text"
          >
            <span *ngIf="totalPrice > 0"> + </span>
            {{ totalPrice | v2Currency }}
          </v2-body-header-heavy-text>
        </v2-chip>

        <v2-icon
          class="modifier-has-children-icon"
          icon="disclosure-right"
          color="primary"
          *ngIf="modifier.modifierGroups.length > 0"
          (click)="onArrowClick($event, modifierGroup, modifier)"
        ></v2-icon>
      </v2-row>

      <v2-unavailable-item-chip
        trailing
        *ngIf="!isModifierSelectable(modifier)"
        [isDisabled]="modifier.disabled"
        [inStock]="modifier.inStock"
      ></v2-unavailable-item-chip>
    </v2-list-tile>

    <v2-list-tile
      [ripple]="shouldShowRippleEffects$ | async"
      class="modifier-group-option"
      (click)="incrementModifierQuantity($event, modifierGroup, modifier)"
      [class.readonly]="locationStore.isMenuReadonly$ | async"
      [class.disabled]="
        modifier.quantity > 0 ||
        isIncrementQtyButtonDisabled(modifierGroup, modifier) ||
        (locationStore.isMenuReadonly$ | async)
      "
      *ngIf="
        itemDetailsStore.isMultiModifierQuantitySelectionEnabled(modifierGroup)
      "
    >
      <v2-column
        leading
        id="qty-picker-selector"
        *ngIf="!(locationStore.isMenuReadonly$ | async)"
      >
        <v2-row id="qty-picker-container" justifyContent="center">
          <v2-center *ngIf="modifier.quantity > 0">
            <v2-center
              class="qty-btn-clickable"
              (click)="
                decrementModifierQuantity($event, modifierGroup, modifier)
              "
            >
              <v2-center
                class="qty-btn fade-in"
                [class.selected]="true"
                v2Ripple
              >
                <v2-icon color="white" icon="minus-symbol"></v2-icon>
              </v2-center>
            </v2-center>
            <v2-center id="qty-display">
              <v2-body-small-text color="primary">
                <span>{{ modifier.quantity }}</span>
              </v2-body-small-text>
            </v2-center>
          </v2-center>

          <v2-center
            class="qty-btn-clickable"
            (click)="incrementModifierQuantity($event, modifierGroup, modifier)"
            [class.disabled]="
              isIncrementQtyButtonDisabled(modifierGroup, modifier)
            "
          >
            <v2-center
              class="qty-btn"
              [class.selected]="modifier.isSelected"
              [class.disabled]="
                isIncrementQtyButtonDisabled(modifierGroup, modifier)
              "
              [class.faded-disabled]="modifier.disabled"
              v2Ripple
            >
              <v2-icon
                [color]="getIncrementQtyButtonColor(modifierGroup, modifier)"
                icon="plus-symbol"
              ></v2-icon>
            </v2-center>
          </v2-center>
        </v2-row>
        <v2-row
          justifyContent="center"
          *ngIf="
            modifier.maximumQty > 0 && modifier.quantity === modifier.maximumQty
          "
        >
          <v2-label-small-text color="medium-grey">
            {{ 'Menu.Modifiers.Max' | translate }}. {{ modifier.maximumQty }}
          </v2-label-small-text>
        </v2-row>
      </v2-column>

      <v2-column title>
        <v2-body-text [color]="getModifierTextColor(modifier, 'dark-grey')">
          {{ modifier.name }}
        </v2-body-text>
        <v2-body-small-text
          *ngIf="modifier.description"
          [color]="getModifierTextColor(modifier, 'medium-grey')"
          class="modifier-description"
        >
          {{ modifier.description }}
        </v2-body-small-text>
      </v2-column>

      <v2-row
        trailing
        alignItems="center"
        *ngIf="isModifierSelectable(modifier)"
      >
        <v2-column
          *ngIf="calculateTotalMultiSelectPrice(modifier) as totalPrice"
        >
          <v2-chip
            [color]="modifier.isSelected ? 'primary-tint' : 'white'"
            size="small"
            [class.no-padding]="locationStore.isMenuReadonly$ | async"
          >
            <v2-body-header-heavy-text
              [color]="getModifierTextColor(modifier, 'medium-grey')"
              class="modifier-price-text"
            >
              <span *ngIf="totalPrice > 0"> + </span>
              {{ totalPrice * (modifier.quantity || 1) | v2Currency }}
            </v2-body-header-heavy-text>
          </v2-chip>

          <v2-label-small-text
            color="medium-grey"
            class="modifier-each-price-text"
            *ngIf="modifier.quantity > 1"
            textAlign="right"
          >
            {{ totalPrice | v2Currency }} ea
          </v2-label-small-text>
        </v2-column>

        <v2-icon
          class="modifier-has-children-icon"
          icon="disclosure-right"
          color="primary"
          *ngIf="modifier.modifierGroups.length > 0"
          (click)="onArrowClick($event, modifierGroup, modifier)"
        ></v2-icon>
      </v2-row>

      <v2-unavailable-item-chip
        trailing
        *ngIf="!isModifierSelectable(modifier)"
        [isDisabled]="modifier.disabled"
        [inStock]="modifier.inStock"
      ></v2-unavailable-item-chip>
    </v2-list-tile>
    <v2-nested-modifiers-selection
      *ngIf="shouldShowNestedModifierSummary(modifier)"
      [modifier]="modifier"
    ></v2-nested-modifiers-selection>
    <v2-divider [inset]="true" *ngIf="!isLast"></v2-divider>
  </ng-container>
</v2-card>
